export default "__VITE_ASSET__CHzaD1D2__"